import { CalendarPostType } from "features/calendar-new/types";
import { Post } from "shared/types/post";

type ApprovalBoardPostAccountFields = Pick<CalendarPostType, "accountIds"> & {
  accountId?: string;
};

export function getApprovalBoardPostAccountIds(
  post: ApprovalBoardPostAccountFields
): string[] {
  if (post.accountIds?.length) return post.accountIds;
  return post.accountId ? [post.accountId] : [];
}

export function toLegacyApprovalPost(post: CalendarPostType): Post {
  return {
    ...(post as Post),
    accountIds: getApprovalBoardPostAccountIds(post),
  };
}

export function toEditableLegacyApprovalPost(post: CalendarPostType): Post {
  const scheduledAt = post.start || post.when;
  const legacyPost = toLegacyApprovalPost(post);
  legacyPost.accountIds = post.accountId
    ? [post.accountId]
    : getApprovalBoardPostAccountIds(post);
  legacyPost.nextRunAt = post.nextRunAt;
  legacyPost.when = scheduledAt as Post["when"];
  legacyPost.lastRunAt = (post.lastRunAt || post.start) as Post["lastRunAt"];
  return legacyPost;
}
